import { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import schLogoMap from '../enquiry/carrier-logo'
import Api from '../state/Api'
import { AgmodalStore, bookingsStore, cargoStore, configStore, containerStore, contractsStore, loginStore } from '../state/CommonState'
import Utils from '../util/Utils'
import { LCL, Line, } from '../components/circle-line'
import { enquiryStore } from '../enquiry/enquiry-data'
import FCLChargeClientViewv3 from './FCLChargeClientView-v3'
import EntityApi1 from "../state/entities-api";
import InsuranceIcon from "../assets/images/icon-02.svg";
import {PremiumInsurance} from "../mytasks/act-coi-confirmation.js";
import { useGlobalState } from '../GlobalState.js'
import { PERMISSIONS_NEW } from '../util/constants.js'
import RoleUtils from '../util/RoleUtils.js'
import TenantUtils from '../util/tenant.utils.js'
import Taskfiledisplay from '../mytasks/task-file-display.js'
import { FCLChargesComp } from '../mytasks/act-update-cost.js'
import { taskStore } from '../mytasks/task-store.js'
import MonApi, { GET_MYACTIONS_APPROVAL_FOR_LOSS_PENDING_URI, GET_MYACTIONS_UPDATE_COST_COMPLETED_URI, UPDATE_BOOKING_FIELDS_URI } from '../state/mongo-api';
import { airChargesBookingStore, chargesBookingStore1, chargesBookingValidationStore, fclChargesBookingStore } from '../mybooksv3/booking-commonstate.js'
import { chargesData1 } from '../StaticData.js'
import BookingsApi from '../state/bookings-api.js'
import { chargesValidationStore } from '../state/validation-stores.js'
import { HistoryModal, ProceedPopup, ToggleButton } from './dummy-schedule-v3.js'
import QuoteCalcV2 from '../util/quote-calc-v2.js'
import { AiChargeHistory, loadAiHistory, getAiHistory } from '../components/AiChargeParse'

export default function FCLScheduleCompv3(props) {
    const [showCharges, setShowCharges] = useState(false)
    const [entityData, SetEntityData] = useState();
    const [premium, setpremium] = useState(false);
    const { currentMenu } = useGlobalState();
    const [edit,setEdit] = useState(false)
    const [activeTab, setActiveTab] = useState('');
    const [showHistory, setShowHistory] = useState(false);
    const [cost, setCost] = useState(false);
    const [costdata, setCostdata] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const [open,setOpen] = useState(false)
    let subscript = -1
    async function chargesListDiff(type) {
        chargesValidationStore.onSaveBtnClicked();
        let chargesList
        if (type.indexOf("FCL") >= 0) {
            type = "FCL"
        }
        if (type.indexOf("FCL") >= 0) {
            fclChargesBookingStore.calculateChargesTotalsindex("list", contractsStore.current.emptycontainerweight);
            chargesList = fclChargesBookingStore.list;
        } else if (type.indexOf("Air") >= 0) {
            airChargesBookingStore.checktotal = airChargesBookingStore.checktotal + 1
            cargoStore.calculateCargoTotals()
            airChargesBookingStore.calculateChargesTotalsindex('list')
            chargesList = airChargesBookingStore.list;
        } else {
            chargesBookingStore1.checktotal = chargesBookingStore1.checktotal + 1
            cargoStore.calculateCargoTotals()
            chargesBookingStore1.calculateLCLChargesTotals()
            chargesList = chargesBookingStore1.list;
        }
        chargesList = chargesList?.filter(e => e.chargeDescription && e.currency)
        let oldCharges = Utils.getChargeList(JSON.parse(JSON.stringify(bookingsStore.current)))
        let result = bookingsStore?.current?.contract?.history?.length > 0 ? bookingsStore?.current?.contract?.history : [];
        result.push({ user: loginStore.email, old: oldCharges?.length > 0 ? oldCharges : [], new: chargesList.length > 0 ? chargesList : [], updatedAt: Date.now() });
        if (chargesList.some(e => e.onaccount == 'On Your Account' && e.total != 0)) {
            let clist = []
            let slist = []
            let cnlist = []
            if (bookingsStore.current.createdFromPricing || bookingsStore.current.contractNum == 'SPOT' || (bookingsStore.current.cartingsheetId != undefined && bookingsStore.current.cartingsheetId.length > 0)) {
                let nl = JSON.parse(JSON.stringify(chargesList.filter(e => e.chargeDescription)))
                for (let i = 0; i < nl.length; i++) {
                    nl[i]['isIncluded'] = 'Yes'
                    if (nl[i]['onaccount'] == 'On Your Account') {
                        clist.push(nl[i])
                    } else if (nl[i]['onaccount'] == `Shipper's Account`) {
                        slist.push(nl[i])
                    } else {
                        cnlist.push(nl[i])
                    }
                }
            }
            let oldchargesList = bookingsStore.current.contract.chargesList
            bookingsStore.current.contract.chargesList = JSON.parse(JSON.stringify(chargesList))
            let k = new QuoteCalcV2(bookingsStore.current.contract).recalc()
            if (k.quoteValue != 0) {
                await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  '_id': bookingsStore.current._id,
  "contract.quoteValue": k.quoteValue,
  "contract.quoteValueUSD": k.quoteValueUSD,
  "contract.chargesList": clist,
  "contract.chargesList": clist,
  "contract.shipperchargesList": slist,
  "contract.consigneechargesList": cnlist,
  "contract.history": result,

  "contract.aiChargeHistory": getAiHistory("bookingCharges")
})
                BookingsApi.getBooking(bookingsStore.current._id, (data) => {
                    Object.assign(bookingsStore.current, data)
                })
                setEdit(false)
            } else {
                bookingsStore.current.contract.chargesList = JSON.parse(JSON.stringify(oldchargesList))
                configStore.setModalMessage(`On your account is empty.`);
            }
        } else {
            configStore.setModalMessage(`On your account is empty.`);
        }
    }
    const onClose = () => {
        setEdit(false)
        BookingsApi.getBooking(bookingsStore.current._id, (data) => {
            contractsStore.current = data.contract
            Object.assign(bookingsStore.current, data)
        })
    }
    
      const onSubmit  = ()=>{
        chargesListDiff(contractsStore.current.shipmentType)
      }
       useEffect(()=>{
        let scope = contractsStore.current.shipmentScope.split('-to-')
                
        let l = []
    
          let type = contractsStore.current.shipmentType
                
           if (props.viewonly) {
                if(JSON.stringify(containerStore.list)!=JSON.stringify(contractsStore.current.containerList)){
                    containerStore.list = JSON.parse(JSON.stringify(contractsStore.current.containerList))
                }
                if(JSON.stringify(cargoStore.cargoList)!=JSON.stringify(contractsStore.current.cargoList)){
                    cargoStore.cargoList = JSON.parse(JSON.stringify(contractsStore.current.cargoList))
                }
                let c
                if(bookingsStore?.current?.contract?.chargesList && bookingsStore?.current?.createdFromPricing){
                  c = Utils.getChargeList(JSON.parse(JSON.stringify(bookingsStore.current)))
                }else{
                  c =contractsStore.current.chargesList
                }
                 
                console.log(activeTab,"activetab");
                if(activeTab=='cost'){
                  c = []
                }
                if(c!=undefined && c.length==0 ){
                    chargesBookingValidationStore.isNew = true
                }else{
                    if(type.indexOf("FCL") >= 0){
                        type = "FCL"
                    }
                    let k = JSON.parse(JSON.stringify(c))
                    if (type.indexOf("FCL") >= 0 && JSON.stringify(fclChargesBookingStore.list)!=JSON.stringify(k)) {
                    fclChargesBookingStore.initialLength = k.length;
                    fclChargesBookingStore.list = k;
                    } else if (type.indexOf("Air") >= 0 && JSON.stringify(airChargesBookingStore.list)!=JSON.stringify(k)) {
                    airChargesBookingStore.initialLength = k.length;
                    airChargesBookingStore.list = k;
                    } else if(JSON.stringify(chargesBookingStore1.list)!=JSON.stringify(k)) {
                    chargesBookingStore1.initialLength = k.length;
                    chargesBookingStore1.list = k;
                    }
                    }
           }
        },[JSON.stringify(contractsStore.current),activeTab,edit])
         const getcost = async () =>{
                if(bookingsStore?.current?._id!='' && activeTab =='Cost'){
                    let l = await MonApi.apost(GET_MYACTIONS_UPDATE_COST_COMPLETED_URI, {
  bookingNum: bookingsStore.current._id
})
                    if(l.length>0){
                        let l1 = await MonApi.apost(GET_MYACTIONS_APPROVAL_FOR_LOSS_PENDING_URI, {
  bookingNum: bookingsStore.current._id
})
                        if(l1.length>0){
                            l[0]['approvestatu'] = "PENDING"
                        }else{
                            l[0]['approvestatu'] = "APPROVE"
                        }
                        if(cost==false){
                            setCost(true)
                        }
                        if(JSON.stringify(l[0])!=JSON.stringify(costdata)){
                            setCostdata(l[0])
                        }
                    }else{
                        if(cost!=false){
                            setCost(false)
                        }
                    }
                }
            }
            useEffect(()=>{
            console.log(costdata,"chekcing for costdata",activeTab);
                getcost()
                
            },[JSON.stringify(AgmodalStore),bookingsStore.current,taskStore.current,taskStore.triggerActionVisible,activeTab])
    const getEntitydata = async () => {
        let entityData = await EntityApi1.viewEntity(rec?.entityId);
        return entityData;
      };
      useEffect(()=>{
        if(entityData==undefined || entityData.length==0){
            getEntitydata().then((data1) => {
                SetEntityData(data1);
              });
        }
      },[])
    useSnapshot(contractsStore)
    useSnapshot(configStore)
    let e = { ...props.data }
    if (!e['POR Code']) e['POR Code'] = e['ocode']
    const [por, setPor] = useState({})
    const [pol, setPol] = useState({})
    const [ts1, setts1] = useState({})
    const [ts2, setts2] = useState({})
    const [pod, setPod] = useState({})
    const [dname, setdname] = useState({})
    if(e['por']!=undefined){
        e['POR Code'] = e['por']
    }
    if(e['pol']!=undefined){
        e['ocode'] = e['pol']
    }
    if(e['pod']!=undefined){
        e['podcode'] = e['pod']
    }
    if(e['fpod']!=undefined){
        e['dcode'] = e['fpod']
        e['fpodcode'] = e['fpod']
    }
    useEffect(() => {
        if (!ts2.location) {
            Api.get4Unloc(e['POR Code'], setPor)
            Api.get4Unloc(e['ocode'], setPol)
            Api.get4Unloc(e['ts1code'], setts1)
            Api.get4Unloc(e['ts2code'], setts2)
            if (e['podcode']) Api.get4Unloc(e['podcode'], setPod)
            Api.get4Unloc(e['dcode'], setdname)
        }
    }, [])
    let rec = contractsStore.current
    if (props.contract) rec = props.contract
    if (!rec) return <></>
    let voldis = 0
    rec['chargesList'].map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        if (e.chargeDescription == 'Volume Discount') {
            voldis = e.total * erate
        }
    })
    let usdRate = configStore.getExchangeRate('USD')
    let voldisusd = voldis / usdRate
    let showOrigin = false
    let showDestination = false
    if (rec.shipmentScope.toLowerCase().indexOf('door-') >= 0) showOrigin = true
    if (rec.shipmentScope.toLowerCase().indexOf('-door') >= 0) showDestination = true
    if (por.location) {
        e['POR Name'] = por.location
    }else{
        e['POR Name'] = e['POR Code']
    }
    if (pol.location) {
        e['oname'] = pol.location
    }else{
        e['oname'] = e['ocode']
    }
    if (ts1.location) e['ts1name'] = ts1.location
    if (ts2.location) e['ts2name'] = ts2.location
    if (pod.location) {
        e['podname'] = pod.location
    } else {
        e['podname'] = e['podcode'] || e['pod'] || ''
    }
    if (dname.location) {
        e['dname'] = dname.location
    }else{
        e['dname'] = e['dcode']
    }
    let showPod = false
    if (e['podcode'] && e['dcode'] && e['podcode'] !== e['dcode']) {
        showPod = true
    } else if (e['pod'] && e['fpod'] && e['pod'] !== e['fpod']) {
        showPod = true
    }
    let srec = {
        porname: e['POR Name'],
        porcode: e['POR Code'],
        departurePor: e['Departure from POR'],
        oname: e['oname'],
        ocode: e['ocode'],
        oetd: e['oetd'] ? Utils.validformatDateShort(e['oetd']) : '',
        r1code: e['r1code'],
        v1name: e['v1name'],
        s1voy: e['s1voy'],
        ts1name: e['ts1name'],
        ts1code: e['ts1code'],
        ts1eta: e['ts1eta'] ? Utils.validformatDateShort(e['ts1eta']) : '',
        ts1etd: e['ts1etd'] ? Utils.validformatDateShort(e['ts1etd']) : '',
        r2code: e['r2code'],
        v2name: e['v2name'],
        s2voy: e['s2voy'],
        ts2name: e['ts2name'],
        ts2code: e['ts2code'],
        ts2eta: e['ts2eta'] ? Utils.validformatDateShort(e['ts2eta']) : '',
        ts2etd: e['ts2etd'] ? Utils.validformatDateShort(e['ts2etd']) : '',
        r3code: e['r3code'],
        v3name: e['v3name'],
        s3voy: e['s3voy'],
        dname: e['dname'],
        dcode: e['dcode'],
        deta: e['deta'] ? Utils.validformatDateShort(e['deta']) : '',
        cscac: e['cscac']
    }
    let eta = e['deta']
    let etd = e['oetd']
    //console.log('ETD =', etd, e['oetd'])
    let etaDate = Utils.newDate(eta)
    let etdDate = Utils.newDate(etd)
    let days = Utils.getDays(etdDate, etaDate)
    let porCode = e['POR Code']
    let polCode = e['ocode']
    let cutoffDate = (porCode === polCode) ? Utils.addDays(etdDate, -3) : Utils.addDays(etdDate, -12)
    let cscac = e['cscac']
    //console.log('CSCAC=', cscac)

    let startDate = Utils.newDate(rec.mailedOn)
    //if (!startDate) startDate = new Date()
    //console.log('%%%%%%%%% startDate=', startDate)
    startDate = Utils.addDays(startDate, 3)
    // The below overrides the above startDate. The below considers only the current date
    // and not the quote start date
    let currentDate = new Date()
    let cargoReadinessDate = (rec.cargoReadinessDate && rec.cargoReadinessDate.length >= 10) ?
        new Date(rec.cargoReadinessDate) : currentDate
    if (cargoReadinessDate < currentDate) cargoReadinessDate = currentDate
    if (isNaN(cargoReadinessDate)) cargoReadinessDate = currentDate
    let startDays = (porCode === polCode) ? 2 : 8 // the logic in mail is >= 4/13, equivalent to this > 3/12
    startDate = Utils.addDays(cargoReadinessDate, startDays)
    if (etdDate < startDate && !props.showbooking) {
        if (loginStore.isClient()) return <></>
        console.log('###CONDITION1', porCode, polCode, 'FAILS= ETD', etdDate, '< Quote Date', startDate)
        return <div>
            POR = {porCode}, POL = {polCode}, CRD = {cargoReadinessDate.toISOString().substring(0, 10)},
            ETD = {etdDate.toISOString().substring(0, 10)},
            Start Date as calculated = {startDate.toISOString().substring(0, 10)}<br />
            CONDITION FAILED = ETD less than Start<hr />
        </div>
    }
    let endDate = Utils.newDate(rec.validUpto)
    let endDays = srec.porname !== srec.oname ? 8 : 2
    //endDate = Utils.addDays(endDate, endDays*-1)
    if (etdDate > endDate && !props.showbooking) {
        if (loginStore.isClient()) return <></>
        console.log('###CONDITION2', porCode, polCode, ' FAILS= ETD', etdDate, '> Valid Upto', endDate)
        return <div>
            POR = {porCode}, POL = {polCode}, CRD = {cargoReadinessDate.toISOString().substring(0, 10)},
            ETD = {etdDate.toISOString().substring(0, 10)},
            End Date as calculated = {endDate.toISOString().substring(0, 10)}<br />
            CONDITION FAILED = ETD greater than END<hr />
        </div>
    }

    const check = (d)=>{
        if(d!=undefined && d.length>0) return true
        return false
    }

    return (
        <div className="box">
             <PremiumInsurance  data={(data)=>{
                console.log("DCs",data)
             setpremium(data)
        }} ></PremiumInsurance>
            <div className="columns" style={{ fontSize: '0.6rem' }}>
                <div className="column is-1" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {
                        (schLogoMap[cscac]) ?
                            <img
                                src={schLogoMap[cscac]}
                                alt={cscac}
                                style={{ maxHeight: '40px', maxWidth: '75px', objectFit: 'contain' }}
                                onError={(e) => {
                                    e.currentTarget.style.display = 'none'
                                }}
                            />
                            : <strong>{cscac}</strong>
                    }
                </div>
                <div className="column is-9">
                    <table className='schtable' style={{ width: '100%', textAlign: 'center' }}>
                        <tr>
                            <td>
                            </td>
                            <td colSpan={8}>
                            {
                                    (days!=undefined && Number(days)>0)?<>
                                    <div style={{ color: 'grey' }}>Total Transit Time</div>
                                    <div style={{ fontSize: '0.9rem' }}><strong>{days} days</strong></div>
                                    </>:""
                                }
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {

                                }
                            </td>
                            <td>Cut-off&nbsp;
                                {
                                    Utils.formatDateShort(cutoffDate)
                                }
                            </td>
                            <td></td>
                            <td>
                            </td>
                            <td>
                                {(check(srec.ts1eta)) ? 'ETA ' + srec.ts1eta : ''}
                            </td>

                            <td>
                            </td>
                            <td>
                                {(check(srec.ts2eta)) ? 'ETA ' + srec.ts2eta : ''}
                            </td>

                            <td>
                            </td>
                            {showPod && (
                                <td>
                                    {(check(e['etapod']) || check(e['ETA (POD)'])) ? 'ETA ' + Utils.validformatDateShort(e['etapod'] || e['ETA (POD)']) : ''}
                                </td>
                            )}
                            <td>
                                {(check(srec.deta)) ? 'ETA ' + srec.deta : ''}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>
                                    {
                                        (showOrigin) ? rec.origin : ''
                                    }
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    {e['POR Name'] !== e['oname'] ? e['POR Name'] : e['oname']}
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    {e['POR Name'] !== e['oname'] ? e['oname'] : ''}
                                </strong>
                            </td>
                            <td>
                                {check(e['v1name'])?e['v1name']:""}{check(e['s1voy'])?`(${e['s1voy']})`:""}
                            </td>
                            <td>
                                <strong>
                                    {e['ts1name']}
                                </strong>
                            </td>
                            <td>
                                {(srec.ts1name) ? <>{check(e['v2name'])?e['v2name']:""}{check(e['s2voy'])?`(${e['s2voy']})`:""}</>:""}
                            </td>
                            <td>
                                <strong>
                                    {e['ts2name']}
                                </strong>
                            </td>
                            <td>
                                {(srec.ts2name) ? <>{check(e['v3name'])?e['v3name']:""}{check(e['s3voy'])?`(${e['s3voy']})`:""}</>:""}
                            </td>
                            {showPod && (
                                <td>
                                    <strong>{e['podname'] || e['pod']}</strong>
                                </td>
                            )}
                            <td>
                                <strong>
                                    {e['dname']}
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    {
                                        (showDestination) ? <>{rec.destination2!=undefined && rec.destination2.length>0?"Multiple":rec.destination}</> : ''
                                    }
                                </strong>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                {
                                    (showOrigin) ? <LCL origin='1' /> : ''
                                }
                            </td>
                            <td>{showOrigin ? <LCL /> : <LCL left='1' />}</td>
                            <td>
                                {
                                    (e['POR Name'] === e['oname']) ?
                                        <Line /> :
                                        <LCL />
                                }
                            </td>
                            <td>
                                <Line />
                            </td>
                            <td>
                                {e['ts1name'] ? <LCL /> : <Line />}
                            </td>
                            <td>
                                <Line />
                            </td>
                            <td>
                                {e['ts2name'] ? <LCL /> : <Line />}
                            </td>
                            <td>
                                <Line />
                            </td>
                            {showPod && (
                                <td>
                                    <LCL />
                                </td>
                            )}
                            <td>
                                {
                                    (showDestination) ?
                                        <LCL /> :
                                        <LCL right='1' />
                                }
                            </td>
                            <td>
                                {
                                    (showDestination) ? <LCL destination='1' /> : ''
                                }
                            </td>
                        </tr>

                        <tr>
                            <td></td>
                            <td>{(e['POR Name'] === e['oname']) ? 'ETD ' + srec.oetd : ''}</td>
                            <td>{(e['POR Name'] !== e['oname']) ? 'ETD ' + srec.oetd : ''}</td>
                            <td>{e['r1code']}</td>
                            <td>{srec.ts1etd ? 'ETD ' + srec.ts1etd : ''}</td>
                            <td>{e['r2code']}</td>
                            <td>{srec.ts2etd ? 'ETD ' + srec.ts2etd : ''}</td>
                            <td>{e['r3code']}</td>
                            {showPod && (
                                <td></td>
                            )}
                        </tr>
                    </table>
                </div>
                <div className='column is-2' style={{ textAlign: 'center' }}>
                    {
                        ((rec.quoteValue + voldis) < 0) ?
                            <>
                                <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(rec.quoteValue)}</strong></div>
                                <div style={{ fontSize: '0.8rem' }}>{Utils.N(rec.quoteValueUSD, 'USD')}</div>
                                <div style={{ fontSize: '1.0rem' }}>(Less) Volume Discount <strong>{Utils.N(voldis)}</strong></div>
                            </> : <>
                                <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(rec.quoteValue + voldis)}</strong></div>
                                <div style={{ fontSize: '0.8rem' }}>{Utils.N(rec.quoteValueUSD + voldisusd, 'USD')}</div>
                            </>
                    }

                    <div style={{ fontSize: '0.6rem', color: 'grey' }}>(Taxes, as Applicable)</div>
                    <div style={{display:"flex",justifyContent: "center", alignItems: "center" }}>
                    {
                        ((!props.viewonly && rec.quoteStatus == 'ACCEPTED')  && (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOAD_SCHEDULE.PLACE_BOOKING) || loginStore.isClient())) ?
                            <button className='button is-rounded is-link is-small' onClick={() => {
                                Utils.checkBookingBlocked({
                                    rec,
                                    data: props.data,
                                    shipmentType: 'FCL',
                                    onProceed: () => {
                                        bookingsStore.initialize()
                                        bookingsStore.current.schedule = props.data
                                        bookingsStore.current.contract = { ...rec }
                                        bookingsStore.current.isInsured = rec.isInsured==='Yes'?'Yes':'No';
                                        bookingsStore.current.enquiry = { ...enquiryStore.current }
                                        bookingsStore.current.fbaDetails = Utils.fbaDetails(rec)
                                        configStore.scheduleOrCarrierform = 'carrierform'
                                    }
                                })
                            }}>
                                Proceed to Booking
                            </button> : <></>
                    }
                    {rec.quoteStatus == 'ACCEPTED'&& currentMenu !="Bookingsv3" && (rec.shipmentType=="LCL"||rec.shipmentType.includes("FCL")) && entityData?.entityCountry.toLowerCase()=="india"
              &&( rec?.portOfReceipt.toLowerCase().includes("india")==true) && TenantUtils.isAgraga() && rec.multidest.length == 1 ?

              <div >
                <button className={
                configStore.scheduleOrCarrierform.toString() === "carrierform"
                  ? "button is-rounded is-link is-small is-hidden"
                  : "blinking"
              }
              style={{marginLeft:"8px",cursor:"pointer",display: "inline-block", border: "none",animation: "blink 1s infinite"}} onClick={()=>{
                   configStore.coiModalVisible2=true
                 }}>
                    <img src={InsuranceIcon} alt="Insurance Icon" width="54" height="70" />
                </button>
            </div>:""}
                    </div>
                    
                </div>
            </div>
            { props.showbooking == '1'?
            <>
                 <div className="columns">
                         {RoleUtils.canViewBookingRevenueDetails() && <div className={RoleUtils.bookingDetailsColumnClass()} style={{ fontSize: "0.8rem" }}>
                           <ToggleButton
                             isOpen={activeTab == 'Revenue'}
                             onClick={() =>{ 
                               setActiveTab(activeTab == 'Revenue' ? '' : 'Revenue')
                               setEdit(false)
                             }}
                             openText="View Revenue Details"
                             closeText="Hide Revenue Details"
                           />
                         </div>}
                         {RoleUtils.canViewBookingCostDetails() && <div className={RoleUtils.bookingDetailsColumnClass()} style={{ fontSize: "0.8rem" }}>
                           <ToggleButton
                             isOpen={activeTab == 'Cost'}
                             onClick={() =>{ 
                               setActiveTab(activeTab == 'Cost' ? '' : 'Cost')
                               setEdit(false)
                             }}
                             openText="View Cost Details"
                             closeText="Hide Cost Details"
                           />
                         </div>}
                       </div>
                  <div className={activeTab === 'Revenue' || activeTab === 'cost' ? 'box' : ''} style={{ fontSize: '0.8rem' }}>
                      {activeTab === 'Revenue' && (
                        <div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      
                      <h4 className="title is-6" style={{ margin: 0 }}>Revenue Details</h4>
                  
                      <div style={{ display: 'flex', gap: '10px' }}>
                        {
                            (!edit && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_CHARGES) && bookingsStore?.current?.contract?.history?.length > 0) ?
                            <button
                              className="button "
                              onClick={() => setShowHistory(true)}
                              style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                            >
                              History
                            </button>:<></>
                        }
                            {
                              (!edit && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_CHARGES) && bookingsStore?.current?.status != 'CANCELLED') ?
                              <button className="button" onClick={()=>{
                                  loadAiHistory("bookingCharges", `${bookingsStore.current?._id}-${Date.now()}`, bookingsStore.current?.contract?.aiChargeHistory)

                                  setEdit(true)
                              }} style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}>Edit</button>
                              :<></>
                            }
                          </div>
                          </div>
                            {!edit && <AiChargeHistory history={bookingsStore?.current?.contract?.aiChargeHistory} chargeKey="all" />}
                            <div
                              className="columns"
                              style={{
                                fontSize: "0.8rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                paddingTop:'20px'
                              }}
                            >
                              {
                                edit?
                                (<FCLChargesComp type={'Edit Charges'} aiScope="bookingCharges" />):<>
                                <div className='column is-6' style={{paddingTop:"0"}}>
                                    <FCLChargeClientViewv3 dummyContract={rec} subscript={subscript} />
                                </div>
                                <div className='column is-6' style={{paddingTop:"0"}}>
                                    {
                                    <>
                                        {rec.shipperchargesList?.length > 0 &&(
                                            <FCLChargeClientViewv3 dummyContract={rec} chargesName='shipperchargesList' />)
                                        }
                                        {rec.consigneechargesList.length > 0 && (
                                            <FCLChargeClientViewv3 dummyContract={rec} chargesName='consigneechargesList' />)
                                        }
                                    </>
                                    }
                                </div>
                            </>
                              }

                            </div>
                            {
                              edit?<div style={{display:'flex',justifyContent:'flex-end',gap:'10px'}}>
                              <button onClick={()=>{
                                onClose()
                              }} className="button is-danger" >Cancel</button>
                              <button onClick={()=>{
                                setOpen(true)
                              }} className="button is-link" >Save</button>
                              </div>:<></>
                            }        
                        </div>
                      )}
                  
                    {activeTab === 'Cost' && (
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <h4 className="title is-6" style={{ margin: 0 }}>Cost Details</h4>
                        </div>
                          <div
                            className="columns"
                            style={{
                              fontSize: "0.8rem",
                              display: "flex",
                              flexDirection:'column',
                              alignItems: "center",
                              justifyContent: "center",
                              paddingTop:'20px'
                            }}
                          >
                            {(cost && costdata)?
                            <>
                                <FCLChargeClientViewv3 dummyContract={costdata}/> 
                            <p><strong>Gross Profit value: </strong>{costdata.profit!=undefined?costdata.profit.toFixed(2):""}</p>
                            <p><strong>Gross Profit percentage: </strong>{costdata.profit_percentage!=undefined?costdata.profit_percentage.toFixed(2):""}</p>
                            {(costdata['approvestatu']!=undefined && costdata['approvestatu']=="PENDING") && <p><strong>Approval for Loss is in pending status.</strong></p>}
                            {
                              costdata?.files?.length > 0&&
                              (<Taskfiledisplay
                             notshow={true} validation={true} task={costdata}/>)
                            } </>:(<h1>No Cost Data available</h1>)
                          }
                          </div>
                      </div>
                    )}
                  </div>
                { open && (
                        <ProceedPopup open={open} close={()=>setOpen(false)} onClick={onSubmit}/>
                )}
                {showHistory && (
                      <HistoryModal type={contractsStore?.current?.shipmentType} show={showHistory} title='Revenue History' data={bookingsStore?.current?.contract?.history || []} onClose={() => setShowHistory(false)}/>
                )}
            </>
            :<>
            <div className="columns" style={{ fontSize: '0.8rem' }}>
                {
                    (showCharges) ?
                        <button className='button is-warning is-small is-fullwidth' onClick={() => setShowCharges(false)}>
                            Hide Detailed Pricing
                            <span className="icon" style={{ marginLeft: '5px' }}>
                                <i className="fas fa-sort-up"></i>
                            </span>
                        </button> :
                        <button className='button is-info is-small is-fullwidth' onClick={() => setShowCharges(true)}>
                            View Detailed Pricing
                            <span className="icon" style={{ marginLeft: '5px' }}>
                                <i className="fas fa-sort-down"></i>
                            </span>
                        </button>
                }

            </div>
            {
                (showCharges) ?
                    <div className="columns" style={{
                        fontSize: '0.8rem',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        {
                            (rec.shipperchargesList?.length > 0 || rec.consigneechargesList?.length > 0) ?
                                <>
                                    <div className='column is-6'>
                                        <FCLChargeClientViewv3 dummyContract={props.contract} />
                                    </div>
                                    <div className='column is-6'>
                                        {
                                            rec.shipperchargesList?.length > 0 ?
                                                <FCLChargeClientViewv3 dummyContract={props.contract} chargesName='shipperchargesList' />
                                                :
                                                <FCLChargeClientViewv3 dummyContract={props.contract} chargesName='consigneechargesList' />
                                        }
                                    </div>
                                </>
                                :
                                <div className='column is-12'>
                                    <FCLChargeClientViewv3 dummyContract={props.contract} />
                                </div>
                        }
                    </div> : <></>
            }</>
        }
        </div>
    )
}

export function FCLScheduleActionCompv3(props) {
    const [showCharges, setShowCharges] = useState(false)
    useSnapshot(contractsStore)
    useSnapshot(configStore)
    let e = { ...props.data }
    if (!e['POR Code']) e['POR Code'] = e['ocode']
    const [por, setPor] = useState({})
    const [pol, setPol] = useState({})
    const [ts1, setts1] = useState({})
    const [ts2, setts2] = useState({})
    const [pod, setPod] = useState({})
    const [dname, setdname] = useState({})
    if(e['por']!=undefined){
        e['POR Code'] = e['por']
    }
    if(e['pol']!=undefined){
        e['ocode'] = e['pol']
    }
    if(e['pod']!=undefined){
        e['podcode'] = e['pod']
    }
    if(e['fpod']!=undefined){
        e['dcode'] = e['fpod']
        e['fpodcode'] = e['fpod']
    }
    useEffect(() => {
        if (!ts2.location) {
            Api.get4Unloc(e['POR Code'], setPor)
            Api.get4Unloc(e['ocode'], setPol)
            Api.get4Unloc(e['ts1code'], setts1)
            Api.get4Unloc(e['ts2code'], setts2)
            if (e['podcode']) Api.get4Unloc(e['podcode'], setPod)
            Api.get4Unloc(e['dcode'], setdname)
        }
    }, [])
    const rec = contractsStore.current
    if (!rec) return <></>
    let showOrigin = false
    let showDestination = false
    if (rec.shipmentScope.toLowerCase().indexOf('door-') >= 0) showOrigin = true
    if (rec.shipmentScope.toLowerCase().indexOf('-door') >= 0) showDestination = true
    if (por.location) e['POR Name'] = por.location
    if (pol.location) e['oname'] = pol.location
    if (ts1.location) e['ts1name'] = ts1.location
    if (ts2.location) e['ts2name'] = ts2.location
    if (pod.location) {
        e['podname'] = pod.location
    } else {
        e['podname'] = e['podcode'] || e['pod'] || ''
    }
    if (dname.location) e['dname'] = dname.location
    let showPod = false
    if (e['podcode'] && e['dcode'] && e['podcode'] !== e['dcode']) {
        showPod = true
    } else if (e['pod'] && e['fpod'] && e['pod'] !== e['fpod']) {
        showPod = true
    }
    let srec = {
        porname: e['POR Name'],
        porcode: e['POR Code'],
        departurePor: e['Departure from POR'],
        oname: e['oname'],
        ocode: e['ocode'],
        oetd: e['oetd'] ? Utils.formatDateShort(Utils.newDate(e['oetd'])) : '',
        r1code: e['r1code'],
        v1name: e['v1name'],
        s1voy: e['s1voy'],
        ts1name: e['ts1name'],
        ts1code: e['ts1code'],
        ts1eta: e['ts1eta'] ? Utils.formatDateShort(Utils.newDate(e['ts1eta'])) : '',
        ts1etd: e['ts1etd'] ? Utils.formatDateShort(Utils.newDate(e['ts1etd'])) : '',
        r2code: e['r2code'],
        v2name: e['v2name'],
        s2voy: e['s2voy'],
        ts2name: e['ts2name'],
        ts2code: e['ts2code'],
        ts2eta: e['ts2eta'] ? Utils.formatDateShort(Utils.newDate(e['ts2eta'])) : '',
        ts2etd: e['ts2etd'] ? Utils.formatDateShort(Utils.newDate(e['ts2etd'])) : '',
        r3code: e['r3code'],
        v3name: e['v3name'],
        s3voy: e['s3voy'],
        dname: e['dname'],
        dcode: e['dcode'],
        deta: e['deta'] ? Utils.formatDateShort(Utils.newDate(e['deta'])) : '',
        cscac: e['cscac']
    }
    let eta = e['deta']
    let etd = e['oetd']
    //console.log('ETD =', etd, e['oetd'])
    let etaDate = Utils.newDate(eta)
    let etdDate = Utils.newDate(etd)
    let days = Utils.getDays(etdDate, etaDate)
    let porCode = e['POR Code']
    let polCode = e['ocode']
    let cutoffDate = (porCode === polCode) ? Utils.addDays(etdDate, -3) : Utils.addDays(etdDate, -12)
    let cscac = e['cscac']
    //console.log('CSCAC=', cscac)

    let startDate = Utils.newDate(rec.mailedOn)
    //if (!startDate) startDate = new Date()
    //console.log('%%%%%%%%% startDate=', startDate)
    startDate = Utils.addDays(startDate, 3)
    // The below overrides the above startDate. The below considers only the current date
    // and not the quote start date
    let currentDate = new Date()
    let cargoReadinessDate = (rec.cargoReadinessDate && rec.cargoReadinessDate.length >= 10) ?
        new Date(rec.cargoReadinessDate) : currentDate
    if (cargoReadinessDate < currentDate) cargoReadinessDate = currentDate
    if (isNaN(cargoReadinessDate)) cargoReadinessDate = currentDate
    let startDays = (porCode === polCode) ? 2 : 8 // the logic in mail is >= 4/13, equivalent to this > 3/12
    startDate = Utils.addDays(cargoReadinessDate, startDays)
    let endDate = Utils.newDate(rec.validUpto)
    let endDays = srec.porname !== srec.oname ? 8 : 2
    //endDate = Utils.addDays(endDate, endDays*-1)

    let voldis = 0
    rec['chargesList'].map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        if (e.chargeDescription == 'Volume Discount') {
            voldis = e.total * erate
        }
    })
    let usdRate = configStore.getExchangeRate('USD')
    let voldisusd = voldis / usdRate
    if (voldis > 0) {
        voldis = -(voldis)
        voldisusd = -(voldisusd)
    }
    const check = (d)=>{
        if(d!=undefined && d.length>0) return true
        return false
    }
    return (
        <div className="box">
            <div className="columns" style={{ fontSize: '0.6rem' }}>
                <div className="column is-1" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {
                        (schLogoMap[cscac]) ?
                            <img
                                src={schLogoMap[cscac]}
                                alt={cscac}
                                style={{ maxHeight: '40px', maxWidth: '75px', objectFit: 'contain' }}
                                onError={(e) => {
                                    e.currentTarget.style.display = 'none'
                                }}
                            />
                            : <strong>{cscac}</strong>
                    }
                </div>
                <div className="column is-9">
                    <table className='schtable' style={{ width: '100%', textAlign: 'center' }}>
                        <tr>
                            <td>
                            </td>
                            <td colSpan={8}>
                            {
                                    (days!=undefined && Number(days)>0)?<>
                                    <div style={{ color: 'grey' }}>Total Transit Time</div>
                                    <div style={{ fontSize: '0.9rem' }}><strong>{days} days</strong></div>
                                    </>:""
                                }
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {

                                }
                            </td>
                            <td>Cut-off&nbsp;
                                {
                                    Utils.formatDateShort(cutoffDate)
                                }
                            </td>
                            <td></td>
                            <td>
                            </td>
                            <td>
                                {(check(srec.ts1eta)) ? 'ETA ' + srec.ts1eta : ''}
                            </td>

                            <td>
                            </td>
                            <td>
                                {(check(srec.ts2eta)) ? 'ETA ' + srec.ts2eta : ''}
                            </td>

                            <td>
                            </td>
                            {showPod && (
                                <td>
                                    {(check(e['etapod']) || check(e['ETA (POD)'])) ? 'ETA ' + Utils.validformatDateShort(e['etapod'] || e['ETA (POD)']) : ''}
                                </td>
                            )}
                            <td>
                                {(check(srec.deta)) ? 'ETA ' + srec.deta : ''}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>
                                    {
                                        (showOrigin) ? rec.origin : ''
                                    }
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    {e['POR Name'] !== e['oname'] ? e['POR Name'] : e['oname']}
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    {e['POR Name'] !== e['oname'] ? e['oname'] : ''}
                                </strong>
                            </td>
                            <td>
                                {check(e['v1name'])?e['v1name']:""}{check(e['s1voy'])?`(${e['s1voy']})`:""}
                            </td>
                            <td>
                                <strong>
                                    {e['ts1name']}
                                </strong>
                            </td>
                            <td>
                                {(srec.ts1name) ? <>{check(e['v2name'])?e['v2name']:""}{check(e['s2voy'])?`(${e['s2voy']})`:""}</>:""}
                            </td>
                            <td>
                                <strong>
                                    {e['ts2name']}
                                </strong>
                            </td>
                            <td>
                                {(srec.ts2name) ? <>{check(e['v3name'])?e['v3name']:""}{check(e['s3voy'])?`(${e['s3voy']})`:""}</>:""}
                            </td>
                            {showPod && (
                                <td>
                                    <strong>{e['podname'] || e['pod']}</strong>
                                </td>
                            )}
                            <td>
                                <strong>
                                    {e['dname']}
                                </strong>
                            </td>
                            <td>
                                <strong>
                                    {
                                        (showDestination) ? <>{rec.destination2!=undefined && rec.destination2.length>0?"Multiple":rec.destination}</> : ''
                                    }
                                </strong>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                {
                                    (showOrigin) ? <LCL origin='1' /> : ''
                                }
                            </td>
                            <td>{showOrigin ? <LCL /> : <LCL left='1' />}</td>
                            <td>
                                {
                                    (e['POR Name'] === e['oname']) ?
                                        <Line /> :
                                        <LCL />
                                }
                            </td>
                            <td>
                                <Line />
                            </td>
                            <td>
                                {e['ts1name'] ? <LCL /> : <Line />}
                            </td>
                            <td>
                                <Line />
                            </td>
                            <td>
                                {e['ts2name'] ? <LCL /> : <Line />}
                            </td>
                            <td>
                                <Line />
                            </td>
                            {showPod && (
                                <td>
                                    <LCL />
                                </td>
                            )}
                            <td>
                                {
                                    (showDestination) ?
                                        <LCL /> :
                                        <LCL right='1' />
                                }
                            </td>
                            <td>
                                {
                                    (showDestination) ? <LCL destination='1' /> : ''
                                }
                            </td>
                        </tr>

                        <tr>
                            <td></td>
                            <td>{(e['POR Name'] === e['oname']) ? 'ETD ' + srec.oetd : ''}</td>
                            <td>{(e['POR Name'] !== e['oname']) ? 'ETD ' + srec.oetd : ''}</td>
                            <td>{e['r1code']}</td>
                            <td>{srec.ts1etd ? 'ETD ' + srec.ts1etd : ''}</td>
                            <td>{e['r2code']}</td>
                            <td>{srec.ts2etd ? 'ETD ' + srec.ts2etd : ''}</td>
                            <td>{e['r3code']}</td>
                            {showPod && (
                                <td></td>
                            )}
                        </tr>
                    </table>
                </div>
                <div className='column is-2' style={{ textAlign: 'center' }}>
                    {
                        ((rec.quoteValue + voldis) < 0) ?
                            <>
                                <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(rec.quoteValue)}</strong></div>
                                <div style={{ fontSize: '0.8rem' }}>{Utils.N(rec.quoteValueUSD, 'USD')}</div>
                                <div style={{ fontSize: '1.0rem' }}>(Less) Volume Discount <strong>{Utils.N(voldis)}</strong></div>
                            </> : <>
                                <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(rec.quoteValue + voldis)}</strong></div>
                                <div style={{ fontSize: '0.8rem' }}>{Utils.N(rec.quoteValueUSD + voldisusd, 'USD')}</div>
                            </>
                    }

                    <div style={{ fontSize: '0.6rem', color: 'grey' }}>(Taxes, as Applicable)</div>
                    {
                        ((!props.viewonly && !loginStore.isClient()) || (!props.viewonly && rec.quoteStatus == 'ACCEPTED')  && (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.UPLOAD_SCHEDULE.PLACE_BOOKING) || loginStore.isClient())) ?
                            <button className='button is-rounded is-link is-small' onClick={() => {
                                Utils.checkBookingBlocked({
                                    rec,
                                    data: props.data,
                                    shipmentType: 'FCL',
                                    onProceed: () => {
                                        bookingsStore.initialize()
                                        bookingsStore.current.schedule = props.data
                                        bookingsStore.current.contract = { ...rec }
                                        bookingsStore.current.enquiry = { ...enquiryStore.current }
                                        bookingsStore.current.fbaDetails = Utils.fbaDetails(rec)
                                        configStore.scheduleOrCarrierform = 'carrierform'
                                    }
                                })
                            }}>
                                Proceed to Booking
                            </button> : <></>
                    }
                </div>
            </div>
            <div className="columns" style={{ fontSize: '0.8rem' }}>
                {
                    (showCharges) ?
                        <button className='button is-warning is-small is-fullwidth' onClick={() => setShowCharges(false)}>
                            Hide Detailed Pricing
                            <span className="icon" style={{ marginLeft: '5px' }}>
                                <i className="fas fa-sort-up"></i>
                            </span>
                        </button> :
                        <button className='button is-info is-small is-fullwidth' onClick={() => setShowCharges(true)}>
                            View Detailed Pricing12
                            <span className="icon" style={{ marginLeft: '5px' }}>
                                <i className="fas fa-sort-down"></i>
                            </span>
                        </button>
                }

            </div>
            {
                (showCharges) ?
                    <div className="columns" style={{
                        fontSize: '0.8rem',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <FCLChargeClientViewv3 />
                    </div> : <></>
            }
        </div>
    )
}